import { render, staticRenderFns } from "./AddressView.vue?vue&type=template&id=6b3b6646&scoped=true&"
import script from "./AddressView.vue?vue&type=script&lang=js&"
export * from "./AddressView.vue?vue&type=script&lang=js&"
import style0 from "./AddressView.vue?vue&type=style&index=0&id=6b3b6646&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b3b6646",
  null
  
)

export default component.exports